exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */[dir=ltr] .live-chat-container{border-right:1px solid #707372}[dir=rtl] .live-chat-container{border-left:1px solid #707372}.live-chat-container .live-chat-icon-container{width:30px;height:30px}[dir] .live-chat-container .live-chat-icon-container{margin-top:7px}.live-chat-container .live-chat-icon-container svg .st0{fill:#707372;stroke:none}.live-chat-container .live-chat-message-container{-ms-flex-align:center;align-items:center}[dir=ltr] .live-chat-container .live-chat-message-container{padding-left:7px}[dir=rtl] .live-chat-container .live-chat-message-container{padding-right:7px}[dir] .live-chat-container .live-chat-message-container .live-chat-link{cursor:pointer}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/live-chat/live-chat.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/live-chat/live-chat.component.scss
// module chunks = 0